export default `
query productSearch(
  $search: String
  $filter: ProductAttributeFilterInput
  $pageSize: Int
  $currentPage: Int
  $sort: ProductAttributeSortInput
) {
  productSearch(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    total_count
    aggregations {
      label
      count
      attribute_code
      options {
        count
        label
        value
        __typename
      }
      position
      __typename
    }
    items {
      __typename
      type_id
      id
      uid
      sku
      sizeguide
      first_child_product
      name
      stock_status
      only_x_left_in_stock
      thumbnail {
        url
        position
        disabled
        label
      }
      url_key
      url_path
      url_rewrites {
        url
      }
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
      }
      ... on GroupedProduct {
        items {
          product {
            sku
          }
        }
      }
      ... on ConfigurableProduct {
        configurable_options {
          attribute_code
          label
          values {
            value_index
            label
            swatch_data {
              value
            }
            uid
          }
        }
        variants {
          attributes {
            code
            label
            uid
            value_index
          }
          product {
            thumbnail {
              url
              label
            }
            uid
            sku
            name
            stock_status
            only_x_left_in_stock
            price_range {
              minimum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
              }
            }
            media_gallery {
                image_types
                media_type
                disabled
                label
                position
                url
            }
            media_gallery_entries {
                disabled
                file
                id
                label
                media_type
                position
                types
                uid
            }
          }
        }
        configurable_product_options_selection {
          configurable_options {
            attribute_code
            label
            values {
              uid
              label
            }
          }
          media_gallery {
            url
            label
            position
            disabled
          }
          variant {
            sku
            name
            price_range {
              maximum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
              }
              minimum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
              }
            }
          }
        }
      }
    }
    page_info {
      page_size
      current_page
      total_pages
    }
  }
}
`;
